<template>
  <div>
    <h1>Calculo</h1>
    <variables></variables>
    <formulas></formulas>
  </div>
</template>
<script>
import Variables from "@/components/Variables.vue";
import Formulas from "@/components/Formulas.vue";
import { mapActions } from "vuex";
export default {
  components: { Variables, Formulas },
  methods: {
    ...mapActions(["listVariables"]),
  },
  mounted() {
    this.listVariables();
  },
};
</script>
